import Swiper, { Autoplay, Pagination } from 'swiper';
Swiper.use([ Autoplay, Pagination ]);

export default () => {
    let container = document.querySelector('.footer-cooperation__slider');
    if (container) {
        let cooperationSlider = slider(container);
    }
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
            delay: 8500,
            disableOnInteraction: true,
        },
        pagination: {
            el: '.swiper-pagination',
        }
    });

    return swiper;
}
